// extracted by mini-css-extract-plugin
export default {"verifiedText":"EmailVerificationFailedBlock_verifiedText__hDJ2M","verifiedBlock":"EmailVerificationFailedBlock_verifiedBlock__pzTJf"};